import { render, staticRenderFns } from "./BaseOrderPage.vue?vue&type=template&id=bd3b3bb6&"
import script from "./BaseOrderPage.vue?vue&type=script&lang=ts&"
export * from "./BaseOrderPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports